import { Pipe, PipeTransform } from '@angular/core';
import { ImageProcessorService } from '@core/service/image-processor.service';

@Pipe({
  name: 'processIcon',
  pure: true
})
export class ImageProcessorPipe implements PipeTransform {

  constructor(private imageProcessor: ImageProcessorService) {}

  transform(base64Icon: string | undefined): Promise<string> | null {
    if (!base64Icon) {
      return null;
    }
    return this.imageProcessor.setTransparentToWhiteFromBase64(base64Icon);
  }
}
